<template>
  <div :class="componentClasses">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  gap: {
    type: String,
    default: "3",
  },
  rowGap: {
    type: String,
  },
  size: {
    type: String,
  },
});

const componentClasses = computed(() => [
  'stk-badges',
  props.gap ? `stk-regap-${props.gap}` : '',
  props.rowGap ? `stk-row-regap-${props.rowGap}` : '',
  props.size ? `stk-size-${props.size}` : '',
]);
</script>


<style>
.stk-badges {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: start;
}
</style>
